module.exports = __webpack_public_path__ + "static/bookshelf-nav-e1b41df4b05bf32775564beae9c7ae26.jpeg";